import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';
import type { FunctionComponent } from 'react';
import { useContext } from 'react';

import { ApplicationContext } from '~/shared/context/context';

type ResetConfigurationModalProps = {
    readonly closeModal: () => void;
    readonly content: string;
    readonly onReset: () => void;
    readonly open: boolean;
    readonly title: string;
};

export const ResetConfigurationModal: FunctionComponent<ResetConfigurationModalProps> = ({
    closeModal,
    content,
    onReset,
    open,
    title,
}) => {
    const { translate } = useContext(ApplicationContext);

    return (
        <Dialog aria-label="Configuration details dialog" open={open}>
            <Grid sx={{ width: '444px' }}>
                <DialogTitle color="text.primary" variant="h4">
                    {title}
                </DialogTitle>
                <DialogContent>
                    {/** biome-ignore lint/security/noDangerouslySetInnerHtml: suppressed due to migration */}
                    <DialogContentText color="text.primary" dangerouslySetInnerHTML={{ __html: content }} />
                </DialogContent>
                <DialogActions>
                    <Button color="secondary" onClick={closeModal}>
                        {translate('common.cancel')}
                    </Button>
                    <Button
                        onClick={() => {
                            onReset();
                            closeModal();
                        }}
                    >
                        {translate('common.reset')}
                    </Button>
                </DialogActions>
            </Grid>
        </Dialog>
    );
};
